// What the turn indicator says: whose go it is, and how much of it is left.
//
// One label rather than a chip beside a chip. The moves counter was its own
// pill, which read as a second fact about the board when it is a fact about
// the sentence next to it — "White to move" and "2 of 2 moves" are one thing
// said twice.

/** The turn indicator, split so the counter can carry its own test id. */
export interface TurnLabel {
  /** "White to move" — the prose half, always said. */
  text: string;
  /** "2/2" — moves left over the turn's total, or null when there is one. */
  moves: string | null;
}

/**
 * The turn indicator's two halves.
 *
 * **The counter appears only when the turn holds more than one move.** A
 * permanent "1/1" in the corner is a number that never changes, which teaches
 * the player to stop reading the corner — and the corner is where the Titan's
 * extra moves have to be legible.
 */
export function turnLabel(sideToMove: string, left: number, total: number): TurnLabel {
  const text = `${sideToMove} to move`;
  if (!Number.isFinite(left) || !Number.isFinite(total) || total <= 1) {
    return { text, moves: null };
  }
  // Clamped rather than trusted: the ceiling is the larger of the allowance
  // and what is left (Reactor Boosters raises one above the other for a turn),
  // and a counter reading "3/2" would be the label arguing with itself.
  const capped = Math.max(0, Math.min(left, total));
  return { text, moves: `${capped}/${total}` };
}
